import { render } from "./Swipernew.vue?vue&type=template&id=8a6bc1e4"
import script from "./Swipernew.vue?vue&type=script&lang=js"
export * from "./Swipernew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__